import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(e: React.SyntheticEvent): void;
  width?: number;
};

export const Edit = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    color = '#0F0A1B',
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 24 24'
    >
      <path
        d='m14.62,4.55c1.32-1.32,3.46-1.32,4.78,0s1.34,3.48.02,4.81l-9.35,9.35-5.81,1,1-5.81S14.62,4.55,14.62,4.55Z'
        fill='none'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3px'
      />

      <line
        x1='13.15'
        y1='6.05'
        x2='17.76'
        y2='10.66'
        fill='none'
        stroke={color}
        strokeLinecap='round'
        strokeWidth='3px'
      />
    </svg>
  );
});

Edit.displayName = 'Edit';
